import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";
import { Student_Get_One_Choose_Fields_From_MongoDB } from "../../../api/Student_Get_One_Choose_Fields_From_MongoDB";

function ViewSEFContactInfo() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [formInfo, setformInfo] = useState([]);

  const [SEFProgress, setSEFProgress] = useState({
    ContactInfo: "",
  });

  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "Contacts",
        setformInfo,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFProgress",
        setSEFProgress,
        logoutStudent
      );
      //GEt Full Stduent for EC later
      Get_One_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        setStudentData,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFProgress",
        setSEFProgress,
        logoutConsultant
      );
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "Contacts",
        setformInfo,
        logoutConsultant
      );

      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, Contacts: 1, SEFProgress: 1 },
        setStudentData,
        logoutConsultant
      );
    }
  }, []);

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  useEffect(() => {
    if (
      window.location.href.indexOf("Student") > -1 &&
      StudentData.IPInfo?.EC_ID
    ) {
      //Get EC
      Student_Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        StudentData.IPInfo?.EC_ID,
        { BasicInfo: 1 },
        setobj_assignedEC,
        logoutStudent
      );
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => {
      // Check if the field being changed is an email field for a specific person
      if (name === "Attendee_Email") {
        const attendeeExists = prevData.some(
          (contact) => contact.Person === "Attendee"
        );
        if (attendeeExists) {
          return prevData.map((contact) =>
            contact.Person === "Attendee"
              ? { ...contact, Email: value }
              : contact
          );
        } else {
          return [...prevData, { Person: "Attendee", Email: value }];
        }
      }

      if (name === "Parent_Email") {
        const attendeeExists = prevData.some(
          (contact) => contact.Person === "Parent"
        );
        if (attendeeExists) {
          return prevData.map((contact) =>
            contact.Person === "Parent" ? { ...contact, Email: value } : contact
          );
        } else {
          return [...prevData, { Person: "Parent", Email: value }];
        }
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          Contacts: formInfo,
          "SEFProgress.ContactInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          Contacts: formInfo,
          "SEFProgress.ContactInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          Contacts: formInfo,
          //SEFProgress: { ContactInfo: "Complete" },
          "SEFProgress.ContactInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          Contacts: formInfo,
          //SEFProgress: { ContactInfo: "Complete" },
          "SEFProgress.ContactInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setSEFProgress({
      ContactInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const requiredFields = ["Attendee_Email", "Parent_Email"];

  const isFormComplete = requiredFields.every(
    (field) =>
      formInfo &&
      formInfo.some((contact) => contact.Person === "Parent") &&
      formInfo.some((contact) => contact.Person === "Attendee") &&
      formInfo.find((contact) => contact.Person === "Parent").Email !== "" &&
      formInfo.find((contact) => contact.Person === "Attendee").Email !== ""
  );

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>Contact Information</h1>
        {SEFProgress &&
        SEFProgress.ContactInfo &&
        (SEFProgress.ContactInfo === "Complete" ||
          SEFProgress.ContactInfo === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}
        <form className="view-basic-info-form">
          <TextField
            label="Student Email"
            variant="outlined"
            fullWidth
            required
            name="Attendee_Email"
            type="email"
            value={
              formInfo.find((contact) => contact.Person === "Attendee")
                ?.Email || ""
            }
            onChange={handleChange}
            InputProps={{
              style: {
                backgroundColor: "white",
                textAlign: "left",
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: "1.2rem", // Increase the font size of the label
                color: "black", // Set the label color to black
              },
            }}
          />
          <TextField
            label="Parent Email"
            variant="outlined"
            fullWidth
            required
            name="Parent_Email"
            type="email"
            value={
              formInfo.find((contact) => contact.Person === "Parent")?.Email ||
              ""
            }
            onChange={handleChange}
            InputProps={{
              style: {
                backgroundColor: "white",
                textAlign: "left",
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: "1.2rem", // Increase the font size of the label
                color: "black", // Set the label color to black
              },
            }}
          />
          <h3>
            {(obj_assignedEC.BasicInfo?.Email &&
              formInfo.find((contact) => contact.Person === "Parent")?.Email &&
              obj_assignedEC.BasicInfo?.Email.toLowerCase() ===
                formInfo
                  .find((contact) => contact.Person === "Parent")
                  ?.Email.toLowerCase()) ||
            //
            (obj_assignedEC.BasicInfo?.Email &&
              formInfo.find((contact) => contact.Person === "Attendee")
                ?.Email &&
              obj_assignedEC.BasicInfo?.Email.toLowerCase() ===
                formInfo
                  .find((contact) => contact.Person === "Attendee")
                  ?.Email.toLowerCase())
              ? //
                "Please provide the student and parent email, there will be a section to provide any additional adults as contacts in the next section"
              : ""}
          </h3>
          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>

          {window.location.href.indexOf("Student") > -1 ? (
            <SEFChangePage
              Page={"ContactInfo"}
              PageButtonStatus={PageButtonStatus}
            />
          ) : (
            <></>
          )}
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (SEFProgress &&
                  SEFProgress.ContactInfo &&
                  (SEFProgress.ContactInfo === "Complete" ||
                    SEFProgress.ContactInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (SEFProgress &&
                  SEFProgress.ContactInfo &&
                  (SEFProgress.ContactInfo === "Complete" ||
                    SEFProgress.ContactInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0 ||
                //Special case, no EC
                (obj_assignedEC.BasicInfo?.Email &&
                  formInfo.find((contact) => contact.Person === "Parent")
                    ?.Email &&
                  obj_assignedEC.BasicInfo?.Email.toLowerCase() ===
                    formInfo
                      .find((contact) => contact.Person === "Parent")
                      ?.Email.toLowerCase()) ||
                //
                (obj_assignedEC.BasicInfo?.Email &&
                  formInfo.find((contact) => contact.Person === "Attendee")
                    ?.Email &&
                  obj_assignedEC.BasicInfo?.Email.toLowerCase() ===
                    formInfo
                      .find((contact) => contact.Person === "Attendee")
                      ?.Email.toLowerCase())
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ViewSEFContactInfo;
